import Dialog from '@zenbusiness/zui/Dialog';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const EmptyDivStyle = () => ({
  width: '40px'
});

export const DialogStyle = ({ theme, borderRadius }) => ({
  zIndex: theme.zIndex.modal,
  padding: 0,
  '.MuiDialog-paper': {
    borderRadius
  }
});

export const DialogTitleStyle = () => ({
  padding: '0px 5px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 60
});

export const TitleStyle = () => ({
  // Those style used for cut off text when it is too long
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
});

export const EmptyDivStyled = styled('div')(EmptyDivStyle);

export const DialogStyled = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'borderRadius'
})(DialogStyle);

export const DialogTitleStyled = styled(DialogTitle)(DialogTitleStyle);

export const TitleStyled = styled(Text)(TitleStyle);
